export default {
  inviteAndEarn: {
    en: 'Invite friends and earn',
  },
  followUs: {
    en: 'Follow Us',
  },
  copyrights: {
    en: 'SCENTBIRD © {year}, All rights reserved. Made with love in NYC.',
  },
  privacyPolicy: {
    en: 'Privacy Policy',
  },
  termsAndConditions: {
    en: 'Terms & Conditions',
  },
  requestFragrance: {
    en: 'Request fragrance',
  },
}
